import { useCallback, useEffect, useState } from "react";
import { MainWrapper } from "./MainWrapper";
import style from "../../assets/scss/sub/downloadTest.module.scss";
import downloadIcon from "../../assets/images/header/download_icon.svg";
import executionIcon from "../../assets/images/header/execution_Icon.png";
import appGuide1 from "../../assets/images/sub/download_test_guide/app_guide_1.png";
import appGuide2 from "../../assets/images/sub/download_test_guide/app_guide_2.png";
import appGuide3 from "../../assets/images/sub/download_test_guide/app_guide_3.png";
import appGuide4 from "../../assets/images/sub/download_test_guide/app_guide_4.png";
import appGuide1En from "../../assets/images/sub/download_test_guide/app_guide_1.svg";
import appGuide2En from "../../assets/images/sub/download_test_guide/app_guide_2_en.png";
import appGuide3En from "../../assets/images/sub/download_test_guide/app_guide_3.svg";
import appGuide4En from "../../assets/images/sub/download_test_guide/app_guide_4.svg";
import webGuide1 from "../../assets/images/sub/download_test_guide/web_guide_1.png";
import webGuide2 from "../../assets/images/sub/download_test_guide/web_guide_2.png";
import webGuide3 from "../../assets/images/sub/download_test_guide/web_guide_3.png";
import webGuide4 from "../../assets/images/sub/download_test_guide/web_guide_4.png";
import webGuide1En from "../../assets/images/sub/download_test_guide/web_guide_1_en.png";
import webGuide2En from "../../assets/images/sub/download_test_guide/web_guide_2_en.png";
import webGuide3En from "../../assets/images/sub/download_test_guide/web_guide_3_en.png";
import webGuide4En from "../../assets/images/sub/download_test_guide/web_guide_4_en.png";
import windowGuide1 from "../../assets/images/sub/download_test_guide/window_guide_1.png";
import windowGuide2 from "../../assets/images/sub/download_test_guide/window_guide_2.png";
import windowGuide3 from "../../assets/images/sub/download_test_guide/window_guide_3.png";
import windowGuide4 from "../../assets/images/sub/download_test_guide/window_guide_4.png";
import windowGuide5 from "../../assets/images/sub/download_test_guide/window_guide_5.png";
import windowGuide1En from "../../assets/images/sub/download_test_guide/window_guide_1_en.png";
import windowGuide2En from "../../assets/images/sub/download_test_guide/window_guide_2_en.png";
import windowGuide3En from "../../assets/images/sub/download_test_guide/window_guide_3_en.png";
import windowGuide4En from "../../assets/images/sub/download_test_guide/window_guide_4_en.png";
import windowGuide5En from "../../assets/images/sub/download_test_guide/window_guide_5_en.png";
import appStoreBadge from "../../assets/images/sub/download_test_guide/app_store_badge.png";
import appStoreBadgeMobile from "../../assets/images/sub/download_test_guide/app_store_badge_mobile.png";
import googlePlayBadge from "../../assets/images/sub/download_test_guide/google_play_badge.png";
import googlePlayBadgeMobile from "../../assets/images/sub/download_test_guide/google_play_badge_mobile.png";
import googlePlayBadgeEn from "../../assets/images/sub/download_test_guide/google_play_badge_en.png";
import appStoreBadgeEn from "../../assets/images/sub/download_test_guide/app_store_badge_en.png";
import googlePlayBadgeMobileEn from "../../assets/images/sub/download_test_guide/google_play_badge_mobile_en.svg";
import appStoreBadgeMobileEn from "../../assets/images/sub/download_test_guide/app_store_badge_mobile_en.svg";
import { ArticleTitle } from "./ArticleTitle";
import { GuideListItem } from "./download/GuideListItem";
import { useUserAgent } from "../../hooks/hooks";
import { useLanguage, useModal } from "../../hooks/hooks";
import { Trans, useTranslation } from "react-i18next";
import { StrongTextStyle } from "../common/StyledCommonComponents";
import { IsDesktopBr } from "../common/IsDesktopBr";
import {GuideWarningArea} from "./download/GuideWarningArea";

enum OSType {
  WINDOW = "window",
  APP = "app",
  WEB = "WEB",
}

export function DownloadTest() {
  const [osType, setOsType] = useState<OSType>(OSType.WEB);
  const { isDesktop } = useUserAgent();
  const { openAlertModal } = useModal();
  const onClickTabMenu = useCallback((type: OSType) => setOsType(type), []);
  const { isKorean } = useLanguage();
  const { t } = useTranslation("downloadTest");

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `검사 다운로드 | ${process.env.REACT_APP_TITLE}`;
  }, []);

  const openPreparingAlert = useCallback(() => {
    // 태블릿, 모바일 화면에서는 .exe파일 다운로드 대신에 모달창 띄워주기
    if (!isDesktop) {
      openAlertModal({
        title: t("alert.window.title"),
        desc: t("alert.window.desc")
      });
    } else {
      window.location.href = "https://images.feel-good.io/setup/dcas/D-CAS.exe";
    }
    // eslint-disable-next-line
  }, [isKorean, isDesktop, openAlertModal]);

  const openDcasWebGame = () => {
    if (!isDesktop) {
      openAlertModal(
          {
            title: t('alert.web.title'),
            desc: t('alert.web.desc'),
          },
      );
    } else {
      window.open('https://dcas-game.feel-good.io');
    }
  }

  const GuideNode = useCallback(() => {
    switch (osType) {
      case OSType.WINDOW:
        return (
          <div className={style.guideContent}>
            <button className={style.downloadBtn} onClick={openPreparingAlert}>
              <Trans t={t} i18nKey={"downloadforWindows"} components={[<IsDesktopBr />, <StrongTextStyle />]} />
              <img className={style.icon} src={downloadIcon} alt={"Window Download Link"} />
            </button>
            <ol className={style.orderedListGuide}>
              <GuideListItem
                number={1}
                normalText={t("firstExp.desc")}
                accentText={t("firstExp.subDesc")}
                imageUrl={isKorean ? windowGuide1 : windowGuide1En}
              />
              <GuideWarningArea
                  title={t("warningWindows.title")}
                  desc={t("warningWindows.desc")}
              />
              <GuideListItem
                number={2}
                normalText={t("secondExp.desc")}
                accentText={t("secondExp.subDesc")}
                imageUrl={isKorean ? windowGuide2 : windowGuide2En}
              />
              <GuideListItem
                number={3}
                normalText={t("thirdExp.desc")}
                accentText={""}
                imageUrl={isKorean ? windowGuide3 : windowGuide3En}
              />
              <GuideListItem
                number={4}
                normalText={t("fourthExp.desc")}
                accentText={t("fourthExp.subDesc")}
                imageUrl={isKorean ? windowGuide4 : windowGuide4En}
              />
              <GuideListItem
                number={5}
                normalText={t("fifthExp.desc")}
                accentText={""}
                imageUrl={isKorean ? windowGuide5 : windowGuide5En}
              />
            </ol>
          </div>
        );
      case OSType.APP:
        return (
          <div className={style.guideContent}>
            <div className={style.googlePlayGuide}>
              <span className={style.text}>
                {t("storeText.desc1")}
                {isDesktop ? <></> : <br />}
                <span className={style.accent}>{t("storeText.desc2")}</span>
              </span>
              <div className={style.badges}>
                {isKorean ? (
                  <>
                    <a
                      href={"https://play.google.com/store/apps/details?id=io.feelgood.dcas"}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <img
                        className={style.badgeImage}
                        src={isDesktop ? googlePlayBadge : googlePlayBadgeMobile}
                        alt={"구글 플레이스토어 뱃지"}
                      />
                    </a>
                    <a href={"https://apps.apple.com/kr/app/d-cas/id6502922927"} target={"_blank"} rel="noreferrer">
                      <img
                        className={style.badgeImage}
                        src={isDesktop ? appStoreBadge : appStoreBadgeMobile}
                        alt={"앱 스토어 뱃지"}
                      />
                    </a>
                  </>
                ) : (
                  <>
                    <a
                      href={"https://play.google.com/store/apps/details?id=io.feelgood.dcas"}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      <img
                        className={style.badgeImage}
                        src={isDesktop ? googlePlayBadgeEn : googlePlayBadgeMobileEn}
                        alt={"구글 플레이스토어 뱃지"}
                      />
                    </a>
                    <a href={"https://apps.apple.com/kr/app/d-cas/id6502922927"} target={"_blank"} rel="noreferrer">
                      <img
                        className={style.badgeImage}
                        src={isDesktop ? appStoreBadgeEn : appStoreBadgeMobileEn}
                        alt={"앱 스토어 뱃지"}
                      />
                    </a>
                  </>
                )}
              </div>
            </div>
            <ol className={style.orderedListGuide}>
              <GuideListItem
                number={1}
                normalText={t("firstAppExp.desc")}
                accentText={t("firstAppExp.subDesc")}
                imageUrl={isKorean ? appGuide1 : appGuide1En}
              />
              <GuideListItem
                number={2}
                normalText={t("secondAppExp.desc")}
                accentText={""}
                imageUrl={isKorean ? appGuide2 : appGuide2En}
              />
              <GuideListItem
                number={3}
                normalText={t("thirdAppExp.desc")}
                accentText={t("thirdAppExp.subDesc")}
                imageUrl={isKorean ? appGuide3 : appGuide3En}
              />
              <GuideListItem
                number={4}
                normalText={t("fourthAppExp.desc")}
                accentText={""}
                imageUrl={isKorean ? appGuide4 : appGuide4En}
              />
            </ol>
          </div>
        );
      case OSType.WEB:
        return (
            <div className={style.guideContent}>
              <button className={style.downloadBtn} onClick={openDcasWebGame}>
                <Trans t={t} i18nKey={"executionForWebs"} components={[<IsDesktopBr />, <StrongTextStyle />]} />
                <img className={style.icon} src={executionIcon} alt={"DCAS Execution Icon"} />
              </button>
              <ol className={style.orderedListGuide}>
                <GuideListItem
                    number={1}
                    normalText={t("firstWebExp.desc")}
                    accentText={t("firstWebExp.subDesc")}
                    imageUrl={isKorean ? webGuide1 : webGuide1En}
                />
                <GuideWarningArea
                    title={t("warningWeb.title")}
                    desc={t("warningWeb.desc")}
                />
                <GuideListItem
                    number={2}
                    normalText={t("secondWebExp.desc")}
                    accentText={""}
                    imageUrl={isKorean ? webGuide2 : webGuide2En}
                />
                <GuideListItem
                    number={3}
                    normalText={t("thirdWebExp.desc")}
                    accentText={t("thirdWebExp.subDesc")}
                    imageUrl={isKorean ? webGuide3 : webGuide3En}
                />
                <GuideListItem
                    number={4}
                    normalText={t("fourthWebExp.desc")}
                    accentText={t("fourthWebExp.subDesc")}
                    imageUrl={isKorean ? webGuide4 : webGuide4En}
                />
              </ol>
            </div>
        );
    }
    // eslint-disable-next-line
  }, [osType, isDesktop, isKorean]);

  return (
    <>
      <MainWrapper showFooter={true} mainClassName={style.downloadTest}>
        <>
          <div className={style.bgItem1}></div>
          <div className={style.bgItem2}></div>
          <div className={style.title}>
            <ArticleTitle title={t("download")} className={""} />
          </div>
          <div className={style.tabMenu}>
            <button
                className={`${style.tab} ${osType === OSType.WEB ? style.active : ""}`}
                onClick={() => onClickTabMenu(OSType.WEB)}
            >
              {t("forWebs")}
            </button>
            {/* [임시] Windows 설치 탭 숨김 → 웹실행으로 통합. 추후 재활성화 시 아래 주석 해제
            <button
              className={`${style.tab} ${osType === OSType.WINDOW ? style.active : ""}`}
              onClick={() => onClickTabMenu(OSType.WINDOW)}
            >
              {t("forWindows")}
            </button>
            */}
            <button
              className={`${style.tab} ${osType === OSType.APP ? style.active : ""}`}
              onClick={() => onClickTabMenu(OSType.APP)}
            >
              {t("forAndroidIos")}
            </button>
          </div>
          {isKorean}
          <GuideNode />
        </>
      </MainWrapper>
    </>
  );
}
